import { EntityType } from '@planone/bau365/util-fair-data';

/**
 * Interface for the 'Watchlist' data
 */
export interface WatchlistItem {
  entity_id: string; // Primary ID
  entity_type: EntityType;
  fair_id: string;
  created_at: string;
}

export type WatchlistItemIdentity = Pick<WatchlistItem, 'entity_id' | 'entity_type' | 'fair_id'>;

export type WatchlistPageContext =
  | 'newsfeed'
  | 'search'
  | 'exhibitors'
  | 'event-details'
  | 'exhibitor-details'
  | 'post-details'
  | 'product-details'
  | 'watchlist'
  | 'home';

export enum WatchlistActionTrigger {
  ADD,
  REMOVE,
  SHARE,
  SHARE_ACTION,
}

export interface WatchlistDocument {
  document_id: string;
}
